import { render, staticRenderFns } from "./TaskHistory.vue?vue&type=template&id=0bfb7067"
import script from "./TaskHistory.vue?vue&type=script&lang=js"
export * from "./TaskHistory.vue?vue&type=script&lang=js"
import style0 from "./TaskHistory.vue?vue&type=style&index=0&id=0bfb7067&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports